import * as React from 'react';
import ReactDOM from "react-dom";
import {PullToRefresh, ListView, SearchBar } from 'antd-mobile'
import './index.less'
import { DingComponent } from '@/components/PageComponent';

interface YdyListViewPropTypes {
  className?: string
  placeholder?: string
  renderHeader?: JSX.Element,
  initialListSize?: number
  ListRow: (rowData, sectionID, rowID, highlightRow) => JSX.Element,
  /** 数据是否全部加载 */
  hasMore: boolean,
  /** 数据加载是否完成 */
  isLoading?: boolean,
  height: number,
  onScroll?: (lv: Element) => void,
  data: any[]
  initList(pageIndex?: number, searchValue?: string): Promise<{pageIndex: number}>
}

interface YdyListViewStateTypes {
  headerHeight: number
  /** 数据加载是否完成 */
  isLoading: boolean,
  /** 下拉刷新是否完成 */
  refreshing: boolean,
  /** 数据源 */
  dataSource: any,
  searchStatus: boolean,
  searchValue: string
}

class YdyListView extends DingComponent<YdyListViewPropTypes, YdyListViewStateTypes> {
  static Item: typeof Item;

  /** 列表实例 */
  private _lv: ListView | null = null
  private _searchBar: SearchBar | null = null
  private _header: React.RefObject<any>
  private _pageIndex: number = 0

  constructor(props: YdyListViewPropTypes) {
    super(props);
    this._header = React.createRef();
    const dataSource = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.state = {
      refreshing: false,
      headerHeight: 0,
      isLoading: true,
      searchStatus: false,
      searchValue: '',
      dataSource
    };
  }

  componentDidMount () {
    if (this._header.current) {
      let header: Element = ReactDOM.findDOMNode(this._header.current) as Element;
      this.setState({headerHeight: header.clientHeight})
    }
  }

  componentWillReceiveProps (props: YdyListViewPropTypes) {
    if ('hasMore' in props) {
      this.setState({
        refreshing: false,
        isLoading: !!props.isLoading,
        dataSource: this.state.dataSource.cloneWithRows(props.data)
      });
    }
  }

  componentNavTitle () {
    if (this._lv) {
      this._lv.scrollTo(0, 0)
    }
  }

  async initList (pageIndex: number) {
    let res = await this.props.initList(pageIndex, this.state.searchValue)
    if (res) {
      this._pageIndex = res.pageIndex || 0
      this.setState({
        refreshing: false,
        isLoading: false,
      });
    }
  }

  /** 下拉刷新 */
  onRefresh = () => {
    this.setState({ refreshing: true, isLoading: true });
    this.initList(0)
  };

  /** 上拉加载更多 */
  onEndReached(event) {
    if (this.state.isLoading && !this.props.hasMore) {
      return;
    }
    this.setState({ isLoading: true });
    this._pageIndex++
    this.initList(this._pageIndex)
  }

  onScroll = (event) => {
    if (this._lv && this.props.onScroll) {
      let lv: Element = ReactDOM.findDOMNode(this._lv) as Element;
      this.props.onScroll(lv)
    }
  }

  renderFooter () {
    if (this.state.isLoading) {
      return <div style={{ padding: 10, textAlign: 'center' }}>加载中...</div>
    } else {
      if (this.props.hasMore) {
        return <div></div>
      } else {
        return <div style={{ padding: 10, textAlign: 'center' }}>没有更多数据了</div>
      }
    }
  }

  render () {
    const {children, className, placeholder, renderHeader, initialListSize, ListRow, height} = this.props
    const {headerHeight, dataSource, searchStatus} = this.state
    return (
      <>
        {
          !renderHeader && (<div className="YdyListView-header" ref={this._header}>
            <SearchBar ref={ref => this._searchBar = ref} placeholder={placeholder || "搜索"}
              onFocus={() => this.setState({searchStatus: true})} onBlur={() => this.setState({searchStatus: false})}
              onClear={value => this.setState({searchValue: value})}
              onSubmit={value => {
                console.log(value);
                
                this.setState({searchValue: value}, () => {
                  this.initList(0)
                })
              }}
              onCancel={value => {
                this.setState({searchValue: value})
                return true;
              }}/>
          </div>)
        }
        {children}
        <ListView ref={ el => this._lv = el }
          className={'YdyListView ' + (className || '')}
          dataSource={dataSource}
          initialListSize={initialListSize || 10}
          renderFooter={this.renderFooter.bind(this)}
          renderRow={ListRow}
          style={{
            width: '100%',
            height: height - headerHeight,
            overflow: 'auto',
            pointerEvents: searchStatus ? 'none' : 'auto'
          }}
          pageSize={4}
          scrollRenderAheadDistance={500}
          onScroll={this.onScroll.bind(this)}
          renderHeader={() => {return renderHeader || <div />}}
          pullToRefresh={
            <PullToRefresh
              direction="down"
              distanceToRefresh={25}
              damping={100}
              getScrollContainer={() => {
                return this._lv
              }}
              indicator={{
                // activate: <div>activate</div>,
                // deactivate: <div>deactivate</div>,
                release: <div>加载中...</div>,
                // finish: <div>finish</div>,
              }}
              refreshing={this.state.refreshing}
              onRefresh={this.onRefresh}
            >
            </PullToRefresh>
          }
          onEndReached={this.onEndReached.bind(this)}
        />
      </>
    );
  }
}

class Item extends React.Component {
  
}

export default YdyListView;


// WEBPACK FOOTER //
// ./src/components/YdyListView/index.tsx